import { connect } from "react-redux";
import InternalCommunication from "./internalCommunication";
import { bindActionCreators } from "redux";
import {
    getContactsList,
    getNotificationUser,
    getProjectsList,
    sendNotification
} from "../../../services/redux/Valet/NotificationCentre/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    contactList: state.SendNotification.contactList,
    projectsList: state.SendNotification.projectsList,
    notificationData: state.SendNotification.notificationData,
    broadcastNotificationUserList: state.SendNotification.broadcastNotificationUserList
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getContactsList,
        getProjectsList,
        documentUploadUrlPublic,
        sendNotification,
        getNotificationUser
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalCommunication);